import styled from 'styled-components'

export const Section = styled.section`
  margin: 5px 0;
  &:first-child {
    margin-top: 1em;
  }
`
